
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/search_input/templates/search"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<input class='query' placeholder='"
    + alias4(((helper = (helper = lookupProperty(helpers,"placeholder_text") || (depth0 != null ? lookupProperty(depth0,"placeholder_text") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"placeholder_text","hash":{},"data":data,"loc":{"start":{"line":1,"column":34},"end":{"line":1,"column":54}}}) : helper)))
    + "' spellcheck='false' type='text' aria-label=\"Search "
    + alias4(((helper = (helper = lookupProperty(helpers,"aria_label_title_text") || (depth0 != null ? lookupProperty(depth0,"aria_label_title_text") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"aria_label_title_text","hash":{},"data":data,"loc":{"start":{"line":1,"column":106},"end":{"line":1,"column":131}}}) : helper)))
    + "\">\n<span class='sprite-global glyph-search'></span>\n";
},"useData":true});
    }).call(this);
  